module.exports = __webpack_public_path__ + "files/5f8a9ac72b37a695ed9ab94f70267058.png";